import { createFileRoute } from '@tanstack/react-router'
import { VideoPage } from '@/features/workspaces/video'

function VideoRouteComponent() {
  const { orgId, workspaceId } = Route.useParams()
  return <VideoPage orgId={orgId} workspaceId={workspaceId} />
}

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/video/'
)({
  staticData: { layout: 'fluid' },
  component: VideoRouteComponent,
})
